angular.
module("dx.webapp.saml", [
	"dx.webapp.datetimeinput",
]);
